import React, { Component } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import Modal from "./modal";
import ModalConfirmation from "./modal_confirmacion";

// Componente para realizar el accordion (el desplegable de toda la vida)

export default class Desplegable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secureDelete: false,
    };
    this.closeModalSecure = this.closeModalSecure.bind(this);
  }

  closeModalSecure() {
    this.setState({ secureDelete: false });
  }

  render() {
    // Hereda en el props una variable boton que le indica si el boton será editar o añadir
    let DeleteBotton = null;
    let EditButton = null;
    let boton = this.props.boton === "Añadir" ? "Añadir" : "Editar"; // Si recibimos un boton añadir el boton que se mostrara será añadir

    // Si podemos editar creamos el boton
    if (this.props.canEdit) {
      EditButton = (
        <Button variant="outline-primary" size="sm" onClick={this.props.handleButtonShow} name={this.props.Toogle} className="float-right mr-4" id={this.props.id} value={this.props.value}>
          {boton}
        </Button>
      );
    }

    // Si es un desplegable de desplegables implementamos el boton de eliminar
    if (this.props.deleteFunction && this.props.canEdit) {
      DeleteBotton = (
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => this.setState({ secureDelete: true })}
          name={this.props.Toogle}
          className="float-right mr-4"
          id={this.props.id}
          value={this.props.value}
        >
          Eliminar
        </Button>
      );
    }

    // EventKey es un campo que tiene accordion bootstrap por defecto que se utiliza para identificar a los desplegables.
    // De esta manera podemos desplegar uno y que se cierre el otro que teniamos abierto
    // Para que esto funcione la etiqueta accordion tiene que englobar todos los desplegables que en este caso son cards
    // En caso de que props.EventKey sea undefined si se engloba todo el componente con el accordion ya que no se cerraran los demás
    // cuando este se abra.
    let eventKey = "99";
    let accordion = null;
    if (this.props.eventKey !== undefined) {
      eventKey = this.props.eventKey;
      accordion = (
        <Accordion>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey={'"' + eventKey + '"'}>
                {this.props.Toogle}
              </Accordion.Toggle>
              {EditButton}
              {
                // Ventana modal que se abrirá para editar los campos (explicado todo en el fichero de su componente)
                // show es una variable que tienes que pasarle por defecto en react bootstrap al componente para
                // saber cuando se debe mostrar y cuando se debe ocultar.
              }
              <Modal show={this.props.showModal} form={this.props.Form} handleButtonShow={this.props.handleButtonShow} toogle={this.props.Toogle} />
            </Card.Header>
            <Accordion.Collapse eventKey={'"' + eventKey + '"'}>
              <Card.Body>{this.props.Text}</Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    } else {
      accordion = (
        <Accordion>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey={'"' + eventKey + '"'}>
                {this.props.Toogle}
              </Accordion.Toggle>
              {DeleteBotton}
              {EditButton}
              <ModalConfirmation
                texto={"¿Está seguro de que quiere eliminarlo?"}
                show={this.state.secureDelete}
                handleButtonShow={this.closeModalSecure}
                deleteFunction={() => this.props.deleteFunction(this.props.id)}
              ></ModalConfirmation>
              <Modal show={this.props.showModal} form={this.props.Form} handleButtonShow={this.props.handleButtonShow} toogle={this.props.Toogle} />
            </Card.Header>
            <Accordion.Collapse eventKey={'"' + eventKey + '"'}>
              <Card.Body>{this.props.Text}</Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    }

    return <React.Fragment>{accordion}</React.Fragment>;
  }
}
